import React, { useEffect } from "react";
import { MainTaskFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Inputs, Buttons } from "components";
import { portalService } from "apiServices";

const MainTaskForm = ({
  initialValues,
  permission,
  productDetail,
  onLoadProductWarrantyBySn,
  onLoadInstrument,
  onSubmit,
  onCancel,
  onDelete,
}) => {
  const schema = yup.object().shape({
    // name: yup.string().required("Reward Name is required"),
    // description: yup.string().required("Description Name is required"),
    warranty_type: yup.string().required("Reward Type is required"),
  });

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const watchTypeField = watch("warranty_type");

  useEffect(() => {
    if (initialValues) {
      reset({
        ...initialValues,
        expired_at: new Date(initialValues.expired_at),
        start_date:
          initialValues.start_date && new Date(initialValues.start_date),
        end_date: initialValues.end_date && new Date(initialValues.end_date),
        img_file: initialValues.img ? [{ media_uri: initialValues.img }] : [],
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const _onSubmit = (values) => {
    let isErr = false;
    if (values.is_same_phone && !productDetail?.cus_phone_number) {
      setError("is_same_phone", {
        type: "custom",
        message: "ไม่มีเบอร์ในระบบ",
      });
      isErr = true;
    }
    if (!values.is_same_phone && !values.sms_phone_number) {
      setError("sms_phone_number", {
        type: "custom",
        message: "กรุณาระบุ",
      });
      isErr = true;
    }
    if (!isErr) {
      onSubmit(values);
    }
  };

  return (
    <MainTaskFormStyled>
      <form onSubmit={handleSubmit(_onSubmit)}>
        <div className="body_form_campaign">
          <div className="input_warp">
            <div className="left_box">Main Task</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      disabled={initialValues ? true : false}
                      errors={errors.main_task_code?.message}
                    />
                  )}
                  name="main_task_code"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Type of Product</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    disabled={initialValues ? true : false}
                    options={[
                      {
                        value: "1",
                        label: "In Warranty",
                      },
                      {
                        value: "2",
                        label: "No Warranty",
                      },
                    ]}
                    errors={errors.warranty_type?.message}
                  />
                )}
                name="warranty_type"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          {watchTypeField && <div className="line" />}
          {!initialValues && (
            <>
              {watchTypeField === "1" && (
                <div className="input_warp">
                  <div className="left_box">
                    In Warranty ( Register product )
                  </div>
                  <div className="right_box">
                    <div className="w50">
                      <Controller
                        control={control}
                        render={({ field }) => (
                          <Inputs.InputAutoSuggestion
                            {...field}
                            apiService={
                              portalService.GET_PRODUCT_WARRANTEE_LIST
                            }
                            query="?status=3&is_member=true&serial_no"
                            field="serial_no"
                            fieldValue="serial_no"
                            errors={errors.product_warranty_ref_id?.message}
                            placeholder="Search S/N"
                            onChangeCustom={onLoadProductWarrantyBySn}
                          />
                        )}
                        name="product_warranty_ref_id"
                        defaultValue=""
                      />
                    </div>
                  </div>
                </div>
              )}
              {watchTypeField === "2" && (
                <div className="input_type_wrap">
                  <div className="itw_left_box">
                    No Warranty ( My Instrument )
                  </div>
                  <div className="itw_right_box ">
                    <Controller
                      control={control}
                      render={({ field }) => (
                        <Inputs.InputAutoSuggestion
                          {...field}
                          apiService={portalService.GET_INSTRUMENT_LIST}
                          query="?keyword"
                          fieldLabel={[
                            "First name",
                            "Last name",
                            "Phone",
                            "Product name",
                            "Brand",
                            "Model",
                            "Series",
                          ]}
                          fieldValue={[
                            "customer_first_name",
                            "customer_last_name",
                            "customer_phone_number",
                            "product_th",
                            "brand",
                            "model",
                            "series",
                          ]}
                          field={"customer_first_name"}
                          disabled={initialValues ? true : false}
                          placeholder={
                            "Search Name or Telephone then select Product"
                          }
                          errors={errors.instrument_ref_id?.message}
                          onChangeCustom={onLoadInstrument}
                        />
                      )}
                      name="instrument_ref_id"
                      defaultValue=""
                    />
                  </div>
                </div>
              )}

              <div className="line" />
            </>
          )}
          {productDetail && (
            <>
              <div className="desc_warp">
                <div className="left_box">Product Owner</div>
                <div className="right_box">
                  <div className="right_box_row">
                    <div className="right_box_row_title">Name</div>
                    <div className="right_box_row_value">
                      {productDetail.cus_first_name}{" "}
                      {productDetail.cus_last_name}
                    </div>
                  </div>
                  <div className="right_box_row">
                    <div className="right_box_row_title">Phone</div>
                    <div className="right_box_row_value">
                      {productDetail.cus_phone_number || "-"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="desc_warp">
                <div className="left_box">Product Detail</div>
                <div className="right_box">
                  <div className="right_box_row">
                    <div className="right_box_row_title">Instrument Type</div>
                    <div className="right_box_row_value">
                      {productDetail.instrument_type_th || "-"}
                    </div>
                  </div>
                  <div className="right_box_row">
                    <div className="right_box_row_title">Name</div>
                    <div className="right_box_row_value">
                      {productDetail.product_th}
                    </div>
                  </div>
                  <div className="right_box_row">
                    <div className="right_box_row_title">Brand</div>
                    <div className="right_box_row_value">
                      {productDetail.product_brand || "-"}
                    </div>
                  </div>
                  <div className="right_box_row">
                    <div className="right_box_row_title">Model</div>
                    <div className="right_box_row_value">
                      {productDetail.product_model || "-"}
                    </div>
                  </div>
                  <div className="right_box_row">
                    <div className="right_box_row_title">Series</div>
                    <div className="right_box_row_value">
                      {productDetail.product_series || "-"}
                    </div>
                  </div>
                  <div className="right_box_row">
                    <div className="right_box_row_title">Serial No</div>
                    <div className="right_box_row_value">
                      {productDetail.product_serial_no || "-"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="line" />
            </>
          )}

          <div className="input_warp">
            <div className="left_box">Sent SMS to</div>
            <div className="right_box center">
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.InputCheckBox
                      {...field}
                      checked={field.value}
                      theme_standard_input_check_box
                      label="Same as data"
                      errors={errors.is_same_phone?.message}
                    />
                  )}
                  name="is_same_phone"
                  defaultValue=""
                />
              </div>

              <div className="w20">
                <div>Or</div>
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      type="text"
                      errors={errors.sms_phone_number?.message}
                    />
                  )}
                  name="sms_phone_number"
                  defaultValue=""
                />
              </div>
            </div>
          </div>

          <div className="btn_zone">
            <div className="w120">
              <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
            </div>
            {permission && (
              <>
                {initialValues && permission.is_delete && (
                  <div className="w120">
                    <Buttons.BgStandard
                      theme_red
                      label="Delete"
                      onClick={onDelete}
                      disabled={!initialValues.is_edit}
                    />
                  </div>
                )}
                {initialValues && permission.is_update ? (
                  <div className="w120">
                    <Buttons.BgStandard
                      type="submit"
                      label="Update"
                      // disabled={initialValues && initialValues.is_center}
                    />
                  </div>
                ) : (
                  permission.is_create && (
                    <div className="w120">
                      <Buttons.BgStandard
                        type="submit"
                        label="Save"
                        // disabled={initialValues && initialValues.is_center}
                      />
                    </div>
                  )
                )}
              </>
            )}
          </div>
        </div>
      </form>
    </MainTaskFormStyled>
  );
};

MainTaskForm.propTypes = {};

export default MainTaskForm;
